import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M6.576 6.576a.6.6 0 0 1 .848 0L12 11.152l4.576-4.576a.6.6 0 1 1 .848.848L12.85 12l4.575 4.576a.6.6 0 0 1-.848.848L12 12.85l-4.576 4.575a.6.6 0 0 1-.848-.848L11.152 12 6.576 7.424a.6.6 0 0 1 0-.848Z"
      clip-rule="evenodd"
    />
  </svg>
`;
